import styled, { css } from 'styled-components';
import { Button } from 'components/Button';

export const StepViewerProgressNavigation = styled.div<{
  $withoutWrapper?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  gap: 32px;
  outline: 1px solid var(--v3-black-2);
  background: var(--v3-black-0);
  box-shadow: 0 -11px 24px rgba(119, 110, 171, 0.08);
  border-radius: 24px;

  ${({ $withoutWrapper }) =>
    $withoutWrapper &&
    css`
      padding: 0;
      outline: none;
      background: transparent;
      box-shadow: none;
      border-radius: 0;
    `}
`;

export const StepViewerProgressNavigationInfo = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: var(--v3-text-color-secondary);
  min-height: 44px;
  display: flex;
  align-items: center;
`;

export const StepViewerProgressNavigationButtonsGroup = styled.div<{
  $block: boolean;
}>`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  justify-content: flex-end;
  ${({ $block }) =>
    $block &&
    css`
      flex: 1;
    `}
`;

export const StepViewerProgressNavigationButton = styled(Button)`
  &&& {
    justify-content: center;
    align-items: center;
    padding: 14px 20px;
    min-width: 112px;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.02em;
    text-align: center;
  }
`;
